import Repository from '@/repositories/repository'

const TradingPageRepository = {
  async getPageTypeOneBySlug(queryParams: any = {}, slug: string, templateType: string) {
    const params = {
      page: '1',
      page_size: '100',
      ...queryParams
    }

    const url = templateType ? `${templateType}|${slug}` : slug;
    
    return await Repository(url, 'page', params);
  }
}

export default TradingPageRepository
